@if (aggregationData; as aggregations) {
  <mat-chip-set>
    @if (hasData$ | async) {
      <div class="mat-chip-header">{{ 'search_chips.selected_filters' | translate }}</div>
    }
    <div class="chip-set-container">
      @if (aggregationKeys.length > 0 && aggregationData) {
        @for (aggregationKey of aggregationKeys; track aggregationKey) {
          @for (option of aggregationData[aggregationKey]?.buckets; track option) {
            @if (option.key && selection[aggregationKey]?.includes(option.key)) {
              <mat-chip [removable]="true" (click)="remove(option.key, aggregationKey)">
                <span>
                  {{ option.key | doenkidsTranslate: translationPrefix + '.' + aggregationKey }}
                  {{ aggregationKey === 'duration' ? ('search_chips.minutes_suffix' | translate) : '' }}
                </span>
              </mat-chip>
            }
          }
        }
      }
    </div>
    <div class="reset-filters-button-container">
      @if (hasData$ | async) {
        <button class="reset-filters-button" (click)="removeAllFilters()">
          <mat-chip class="reset-filters-chip">{{ 'search_chips.clear_filters' | translate }} </mat-chip>
        </button>
      }
    </div>
  </mat-chip-set>
}
